
import styled from "styled-components";
import popup1 from "../assets/popup1mobile.png";
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useEffect } from 'react'

function PopUp1Mobile({ doNotShowToday, close,popup }) {



  const navigate = useNavigate()
  return (
    <Bg>
      <Container>
        <Img src={process.env.REACT_APP_BASE_RESOURCES_API +  popup.popupFileDto.filePath}
          onClick={() => {
            debugger
            if (popup.popupUrl === null) return false;
            if(popup.popupUrl.indexOf('http')>-1){
              window.location.href=popup.popupUrl;
              return;
            }
            navigate(popup.popupUrl)
          }}
           />
        <Row>
          <Btn1 onClick={doNotShowToday}>오늘 하루 보지 않기</Btn1>
          <Btn2 onClick={close}>닫기</Btn2>
        </Row>
      </Container>
    </Bg>
  );
}

export default PopUp1Mobile;
const Bg = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
`;
const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  z-index: 1001;
  border-radius: 26px 26px 0 0;
  overflow: hidden;
`;
const Img = styled.img`
  object-fit: contain;
`;
const Row = styled.div`
  width: 100vw;
  height: 63.3px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Btn1 = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Noto Sans KR;
  font-weight: 400;
  color: #4f4f4f;
  font-size: 14.3px;
  margin-left: 20px;
`;
const Btn2 = styled(Btn1)`
  font-weight: 700;
  color: #4f4f4f;
  margin-right: 32px;
`;
